"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoricalPerformancesResponse = void 0;
// eslint-disable-next-line @typescript-eslint/no-namespace
var HistoricalPerformancesResponse;
(function (HistoricalPerformancesResponse) {
    function fromJSON(json) {
        return json.historicalPerformances.map((hp) => {
            return {
                eventId: hp.eventId,
                stats: hp.stats.map((stat) => {
                    return {
                        market: stat.statKey,
                        value: stat.value,
                        displayOrder: stat.displayOrder,
                    };
                }),
            };
        });
    }
    HistoricalPerformancesResponse.fromJSON = fromJSON;
})(HistoricalPerformancesResponse || (exports.HistoricalPerformancesResponse = HistoricalPerformancesResponse = {}));
//# sourceMappingURL=historical_performances_request.js.map